const traverseNestedObjectAndGrabValue = (
  values: unknown,
  field: string
): (string | number | { [key: string]: string | number })[] => {
  const grabFromIndex = (values: any, path: string) => {
    if (!values) return null;

    const hasIndex = path.match(/\[([0-9]+)\]/);
    if (hasIndex?.length) {
      const index = hasIndex[1];
      const location = path.replace(/\[[0-9]+\]/, '');
      return values?.[location]?.[index];
    } else return values[path];
  };

  const path = field.split('.');
  if (path.length > 1) {
    return traverseNestedObjectAndGrabValue(
      grabFromIndex(values, path[0]),
      path.slice(1).join('.')
    );
  } else return grabFromIndex(values, path[0]);
};

export default traverseNestedObjectAndGrabValue;
